<h4 class="category-subtitle">Categories:</h4>
@if (selectedCategory && foodCategories) {
  <div
    class="category-icons-container"
    >
    @for (category of foodCategories; track category) {
      <div>
        <button
          class="category-select-btn"
          [class.answered]="hasEntries(category)"
          [class.selected]="selectedCategory.id === category.id"
          (click)="selectCategory(category)"
          >
          <app-icon [name]="category.icon || 'apple'" color="black"></app-icon>
        </button>
      </div>
    }
  </div>
}
@if (selectedCategory) {
  <div>
    <p class="category-title">
      How many servings of
      <b>{{ selectedCategory.text.text_en || "" }}</b> did you consume today?
    </p>
    @for (food of selectedCategory.foods; track food) {
      <div class="category-item">
        <b class="category-item-name">{{ food.text.text_en }}</b>
        <p class="category-item-description">
          e.g. {{ food.servingText.text_en }} ({{ food.servingSize }}{{ food.unit }})
        </p>
        <div class="increment-decrement-controls">
          <button
            (click)="decrementAmount(food.id)"
            class="increment-decrement-button"
            >
            -
          </button>
          <input
            matInput
            type="text"
            min="0"
            step="1"
            placeholder="0"
            disabled
            [value]="getAmountForFood(food.id)"
            class="amount-indicator"
            />
          <button
            (click)="incrementAmount(food.id)"
            class="increment-decrement-button"
            >
            +
          </button>
        </div>
        <div class="airplane-checkbox-container" [ngClass]="{'airplane-disabled': getAmountForFood(food.id) === 0}">
          <input
            type="checkbox"
            [id]="'imported-' + food.id"
            [checked]="isImportedByAirplane(food.id) && getAmountForFood(food.id) > 0"
            (change)="toggleImportedByAirplane(food.id, $event)"
            [disabled]="getAmountForFood(food.id) === 0"
            />
          <app-icon
            class="airplane-icon"
            name="plane"
            color="#000"
            matTooltip="Check if this food was imported by airplane."
            matTooltipPosition="above"
          ></app-icon>
        </div>
      </div>
    }
    <div class="continue-button-container">
      <button class="btn" (click)="onContinue()">
        Continue
        @if (selectedCategory) {
          <app-icon
            [name]="getNextCategoryIcon(selectedCategory)"
            size="24px"
            color="#fff"
          ></app-icon>
        }
      </button>
    </div>
  </div>
}
